import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Renungan from "../views/Renungan.vue";
import Gallery from "../views/Gallery.vue";
import GalleryDetail from "../views/GalleryDetail.vue";
import ErrorPage from "../components/Error.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery
  },
  {
    path: "/renungan",
    name: "Renungan",
    component: Renungan
  },
  {
    path: "/gallery/:id",
    name: "GalleryDetail",
    component: GalleryDetail
  },
  {
    path: "*",
    name: "Error",
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
